import { useContext, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { AppSpan, CustomContainer, FixedContainer, SidePopupContainer } from "src/style"
import { DisplayBox } from "src/popup"


export const MoreFeature: React.FC<any> = ({top, left, close}) => {
    const {API} = useContext(ApiContext)
    const [showPopup, setShowPopup] = useState(false)
    const [data, setData] = useState<any>(null)

    async function handleClick (type: string) {
        const response = type === 'password' ? await API.generatePasswordResetLinkForUser() : null
        if (!response) return close()

        let title = type === 'otp' ? 'OTP Generation' : 'Password reset link generation'
        let text = type === 'otp' ? 
            'You generated an OTP for this user. The OTP has been sent to the user’s phone number & email.'
            : 'You generated an password reset link for this user. The link has been sent to the user’s email.'
        
            setData({title, text})
            setShowPopup(true)
    }
    
    return (
        <>
            <SidePopupContainer  onClick={close} bgColor='transparent' />
            <FixedContainer 
                top={top || '75'} left={left || "49.5"} zIndex="8"
                className="new-creation-container"  
            >
                <CustomContainer 
                    width='27' height='12' bgColor='#ffffff' 
                    radius='0.8' padding='1'
                    className='more-feature-box'
                >
                    <AppSpan className="new-creation-text" onClick={() => handleClick('otp')} >Generate OTP for user</AppSpan>
                    <AppSpan className="new-creation-text" onClick={() => handleClick('password')} >Reset password for user</AppSpan>
                </CustomContainer>
            </FixedContainer>
            { showPopup &&
                <DisplayBox 
                    close={() => setShowPopup(false)}
                    title={data?.title}
                    text={data?.text}
                    btnText={data?.btnText}
                />
            }
        </>
    )
}